module.exports = "/*\n * CONDITIONAL AnalyticsEvent\n */\nfunction AnalyticsConditionalEvent(name, options) {\n\tthis.build(name, options);\n\tthis.condition = '';\n\tthis.init = function() {\n\n\t\tif (!eval(this.condition)) return false; // jshint ignore:line\n\t\tthis.send();\n\t};\n}\n// > Inheritance\nAnalyticsConditionalEvent.prototype = AnalyticsEvent.prototype;"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/analytics/legacy/framework/events/AnalyticsConditionalEvent.legacy.js
// module id = 802
// module chunks = 31